import '@babel/polyfill';
import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store/index';
// import './registerServiceWorker';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/css/site.css';
import tagManager from './gtmEventHandler.js';
import Vuelidate from 'vuelidate';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faExclamationCircle,
    faPlusCircle,
    faMinusCircle,
    faCaretRight,
    faSpinner,
    faBoxOpen,
    faUpload,
    faInfoCircle,
    faEnvelope,
    faFile,
    faFileAlt,
    faFileInvoiceDollar,
    faTruck,
    faCheckCircle,
    faBox,
    faTimesCircle,
    faCheck,
    faFolderPlus,
    faFolder,
    faArchive,
    faWarehouse,
    faSearch,
    faFileInvoice,
    faTasks,
    faEdit,
    faTrashAlt,
    faSave,
    faQuestionCircle,
    faArrowCircleRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueCookies from 'vue-cookies';

import VueProgressBar from 'vue-progressbar';

import { authService } from './msal';
Vue.prototype.$AuthService = authService;
Vue.use(VueProgressBar, {
    color: 'gray',
    failedColor: 'red',
    thickness: '1px',
    height: '1px',
    autoFinish: false
});

library.add(faExclamationCircle);
library.add(faPlusCircle);
library.add(faMinusCircle);
library.add(faCaretRight);
library.add(faSpinner);
library.add(faBoxOpen);
library.add(faUpload);
library.add(faInfoCircle);
library.add(faEnvelope);
library.add(faFile);
library.add(faFileAlt);
library.add(faFileInvoiceDollar);
library.add(faTruck);
library.add(faCheckCircle);
library.add(faBox);
library.add(faTimesCircle);
library.add(faCheck);
library.add(faFolderPlus);
library.add(faFolder);
library.add(faArchive);
library.add(faWarehouse);
library.add(faSearch);
library.add(faFileInvoice);
library.add(faTasks);
library.add(faEdit);
library.add(faTrashAlt);
library.add(faSave);
library.add(faQuestionCircle)
library.add(faArrowCircleRight)
Vue.component('font-awesome-icon', FontAwesomeIcon);

import i18n from './i18n';

Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.use(BootstrapVue);

import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
    id: 'GTM-P5847FG', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    queryParams: {
        // Add url query string when load gtm.js with GTM ID (optional)
        gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
        gtm_preview: 'env-4',
        gtm_cookies_win: 'x'
    },
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [] // If router, you can exclude some routes name (case insensitive) (optional)
});

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

Vue.config.errorHandler = (err, vm, info) => {
    console.error('Exception: ', err);
    console.error('vm', vm);
    tagManager.addEvent({ 'event': 'vueError', 'error': err })
};



Vue.config.productionTip = false;
export const app = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
}).$mount('#app');
